/* eslint-disable filenames/match-regex */
import { t } from '@lingui/macro';
import i18n from '@rover/utilities/translation';

export const BrainTreeCreditCardConstants = {
  creditCardNumberPlaceholder: i18n._('Credit Card Number'),
  isInvalidCreditCardString: i18n._('Enter a valid credit card number.'),
  isInvalidExpirationDateString: i18n._('Enter a valid expiration date.'),
  isInvalidCVVString: i18n._('Enter a valid CVV'),
  braintreeErrorMessage: i18n._(
    'There was an error processing your credit card, please try again later.'
  ),
};

export const ContactInfoConstants = {
  emergencyContactInfo: i18n._('Emergency contact info'),
  incomplete: i18n._('INCOMPLETE'),
  contactName: i18n._('Contact name'),
  phoneNumber: i18n._('Phone number'),
  phoneNumberInvalid: i18n._('Phone numbers must be valid'),
  complete: i18n._('COMPLETE'),
  updateEmergencyContactInfo: i18n._('Update emergency contact info'),
  save: i18n._('Save'),
};

export const CollapsingCheckboxCollectionConstants = {
  filters(totalSelected) {
    return i18n._(t`Filters (${totalSelected})`);
  },
  resetAll: i18n._('Reset all'),
};

export const ContactSitterPageConstants = {
  message: i18n._('Message'),
  youCanMessageProvider(providerName) {
    return i18n._(
      t`You can chat with ${providerName} right after you finish sending this request.`
    );
  },
  bookingAndPayingOnRoverIsRequired: i18n._(
    t`<strong>Booking and paying on Rover is required</strong> per Rover's Terms of Service.`
  ),
  atLeastOneDayIsRequired: i18n._('Please select at least one day'),
  fromPlaceholder: i18n._('From'),
  toPlaceholder: i18n._('To'),
  startBetweenTitle: i18n._('Start Between'),
  endBetweenTitle: i18n._('End Between'),
};

export const MessageFormConstants = {
  shareAlittleInfoAboutYourPet(providerName) {
    return i18n._(
      t`Share a little info about your pet and why they'd have a great time with ${providerName}`
    );
  },
};

export const PhoneInfoFormConstants = {
  whatIsYourPhoneNumber: i18n._('What is your phone number?'),
  forYourSafetyAndSecurity(providerName, notifyPhoneNumber) {
    return i18n._(
      t`For your safety & security, Rover will not expose your phone number until you've booked your stay. Messages from ${providerName} will come from <strong>${notifyPhoneNumber}</strong>, a number owned by Rover.`
    );
  },
  textMeWhenReplies(providerName) {
    return i18n._(t`Text me when ${providerName} replies.`);
  },
};

export const PhotosFormConstants = {
  iWouldLikeToReceivePhotos: i18n._("I'd like to receive photos of my pet(s) during this stay."),
};

export const SdvCalloutConstants = {
  withRoverCards(providerName, service) {
    return i18n._(
      t`With Rover Cards, you'll know when ${providerName} starts the service (${service}). Afterward, you'll receive a summary including walk info (if one happened), photos, and any pet events that occurred.`
    );
  },
};

export const TosFormConstants = {
  iAgreeToRoverdotcom: i18n._('I agree to the Rover.com'),
  termsOfService: i18n._('Terms of Service'),
};

export const UnavailableModalConstants = {
  title: i18n._("Let's find some great dog walkers"),
  buttonTextClose: i18n._('Back'),
  buttonText: i18n._('Search for local dog walkers'),
  notAvailableMessage(zipCode) {
    return i18n._(
      t`Rover Now is not available in ${zipCode} yet but you can still find someone great in your neighborhood within the nation's largest network of dog walkers.`
    );
  },
};

export const EmergencyFormConstants = {
  petsSafetyInfo: i18n._("Your pet's safety info"),
  missedPetsSafetyInfo: i18n._("We're missing some safety info"),
  filtersSitter(petList) {
    return i18n._(t`Make sure all the information for ${petList} is up-to-date for your sitter`);
  },
  returnButton: i18n._('Return to Conversation'),
};

export const VetInfoConstants = {
  title: i18n._('Veterinary Info'),
  incomplete: i18n._('INCOMPLETE'),
  complete: i18n._('COMPLETE'),
  updateButton: i18n._('Update veterinary info'),
  save: i18n._('Save'),
  contactInfo: i18n._('Add your veterinarian’s name & contact info'),
};

export const CareInstructionsConstants = {
  title: i18n._('Care instructions'),
  incomplete: i18n._('INCOMPLETE'),
  complete: i18n._('COMPLETE'),
  instructionsReminder: i18n._(
    "Be sure to include your dog's typical meal and potty schedule, how much you feed them, and any medication instructions"
  ),
  updateButton: i18n._('Update care instructions'),
  save: i18n._('Save'),
};

export const ContactDateAndTimeConstants = {
  errorMessage: i18n._('Please select a date'),
  shouldThisBookingRepeat: i18n._('Should this booking repeat every week?'),
  repeatOptions: {
    yes: i18n._('Yes'),
    no: i18n._('No'),
  },
};

export const ContiguousTimesConstants = {
  placeholder: i18n._('Select a date'),
  defaultPlaceholder: i18n._('Select a Date'),
  dropOff: i18n._('Drop-off'),
  pickUp: i18n._('Pick-up'),
  start: i18n._('Start'),
  end: i18n._('End'),
  dropOffMessage: i18n._('When would you like to drop off?'),
  pickUpMessage: i18n._('When would you like to pick up?'),
  startMessage: i18n._('When would you like to start?'),
  endMessage: i18n._('When would you like to end?'),

  requestedPickUpAndDropOffFrom(requesterName, addressLine1, addressLine2, city, state, zip) {
    return i18n._(
      t`${requesterName} requested pick-up and drop-off from:
${addressLine1} ${addressLine2}
${city}, ${state} ${zip}

`
    );
  },
  requestedPickUpAndDropOffForTheStay(requesterName) {
    return i18n._(
      t`${requesterName} requested pick-up and drop-off for this stay. Please confirm their address before booking this stay.

`
    );
  },
  pickUpBetweenTimesOnADate(earliest, latest, date) {
    return i18n._(t`Pick-up: between ${earliest} and ${latest} on ${date}`);
  },
  dropOffBetweenTimesOnADate(earliest, latest, date) {
    return i18n._(t`Drop-off: between ${earliest} and ${latest} on ${date}`);
  },
  startBetweenTimesOnADate(earliest, latest, date) {
    return i18n._(t`Start: between ${earliest} and ${latest} on ${date}`);
  },
  endBetweenTimesOnADate(earliest, latest, date) {
    return i18n._(t`End: between ${earliest} and ${latest} on ${date}`);
  },
  pickUpOnADate(date) {
    return i18n._(t`Pick-up on ${date}`);
  },
  dropOffOnADate(date) {
    return i18n._(t`Drop-off on ${date}`);
  },
  startOnADate(date) {
    return i18n._(t`Start on ${date}`);
  },
  endOnADate(date) {
    return i18n._(t`End on ${date}`);
  },
};

export const EnhancedAddOnsConstants = {
  extrasAndUpgrades: i18n._('Extras and upgrades'),
  treatYourself: i18n._('Treat yourself (and your dog!) by upgrading your booking.'),
  noteYourAddress: i18n._('Note: Your address will be shared with the sitter.'),
};

export const FrequencyToggleConstants = {
  howOftenDoYouNeed: i18n._('How often do you need #[span.service service_name]?'),
  howOften: i18n._('How often?'),
  oneTime: i18n._('One Time'),
  repeatWeekly: i18n._('Repeat Weekly'),
};

export const NonContiguousTimesConstants = {
  whatDaysWouldYouLike(serviceSlug) {
    return serviceSlug === 'dog-walking'
      ? i18n._('What days would you like walks?')
      : i18n._('What days would you like day care?');
  },
  providerMayArrive(providerName) {
    return i18n._(t`${providerName} may arrive an hour earlier or later than the time you select.`);
  },
  whichDates: i18n._('Which dates?'),
  addAndSelectPeferredTimes(serviceSlug) {
    return serviceSlug === 'dog-walking'
      ? i18n._('Add and select preferred times for walks below')
      : i18n._('Add and select preferred times for your visits below');
  },
  selectYourPreferredPickUpDropOff: i18n._('Select your preferred pick-up and drop-off times'),
  selectYourPreferredDropOffPickUp: i18n._('Select your preferred drop-off and pick-up times'),
  selectYourPreferredStartEnd: i18n._('Select your preferred start and end times'),
  whenWouldYouLikeToStart: i18n._('When would you like to start?'),
  pickUpBetween: i18n._('Pick-up Between'),
  dropOffBetween: i18n._('Drop-off Between'),

  serviceRequestRecurring(serviceName, startDate) {
    return i18n._(t`${i18n._(serviceName)} Request - Repeat Service starting on ${startDate}`);
  },
  serviceRequestOneTime(serviceName) {
    return i18n._(t`${i18n._(serviceName)} Request - One Time:`);
  },
  pickUpBetweenWithDates(earliest, latest) {
    return i18n._(t`Pick-up Between: ${earliest} and ${latest}`);
  },
  dropOffBetweenWithDates(earliest, latest) {
    return i18n._(t`Drop-off Between: ${earliest} and ${latest}`);
  },
  startBetweenWithDates(earliest, latest) {
    return i18n._(t`Start Between: ${earliest} and ${latest}`);
  },
  endBetweenWithDates(earliest, latest) {
    return i18n._(t`End Between: ${earliest} and ${latest}`);
  },
  pudoMessageWithAddress(requesterName, addressLine1, addressLine2, city, state, zip) {
    return i18n._(
      t`${requesterName} requested pick-up and drop-off from:
${addressLine1} ${addressLine2}
${city}, ${state} ${zip}

`
    );
  },
  pudoMessageWithoutAddress(requesterName) {
    return i18n._(
      t`${requesterName} requested pick-up and drop-off for this stay. Please confirm their address before booking this stay.

`
    );
  },
  recurringFrequencyText(date) {
    return i18n._(
      /* i18n:
      {date} is formatted date e.g. Jun 02, 2018 or 02 juin 2018
      */
      t`Repeat Service starting on ${date}`
    );
  },
  oneTimeFrequencyText: i18n._('One Time:'),
  recurringNumUnitMessage(count, unitText, weekday, times) {
    return i18n._(
      /* i18n: 2 walks on Sunday at 10:00 AM */ t`${count} ${unitText} on ${weekday} at ${times}`
    );
  },
  nonRecurringNumUnitMessage(count, unitText, date, times) {
    return i18n._(
      /* i18n: 2 walks on Sat, Jun 02 at 10:00 AM */ t`${count} ${unitText} on ${date} at ${times}`
    );
  },
};

export const LastUpdatedTimestampsConstants = {
  neverUpdated: i18n._('Never updated'),
  updatedToday: i18n._('Last updated today'),
  updatedAgo(humanizedTimeSinceUpdated) {
    return i18n._(t`Last updated ${humanizedTimeSinceUpdated} ago`);
  },
  saveButtonText: i18n._('Save'),
};

export const AddPetFormConstants = {
  errorMessage: i18n._('Please select at least one pet'),
  addAdditionalPet: i18n._('Add additional pet'),
};

export const AddPetFormRowConstants = {
  enterInformationForPet(petName) {
    return i18n._(t`Enter information for ${petName}`);
  },
  updateInformationForPet(petName) {
    return i18n._(t`Update information for ${petName}`);
  },
  labelDog: i18n._('Dog'),
  labelCat: i18n._('Cat'),
  labelName: i18n._('Name'),
  nameRequired: i18n._('Name Required'),
  labelWeightWithUnit(weightUnit) {
    return i18n._(/* i18n: e.g 'Weight (lbs)' */ t`Weight (${weightUnit})`);
  },
  labelWeight: i18n._('Weight'),
  labelBreeds: i18n._('Breed(s)'),
  placeholderBreeds: i18n._('Breeds'),
  enterBreedsMessage: i18n._('Enter all breeds that apply'),
  enterBreedsMessageDog: i18n._('If your dog is a mixed breed, add ‘Mixed’ as well.'),
  enterBreedsMessageCat: i18n._(
    /* i18n: e.g 'Enter all breeds that apply (optional).' */ '(optional).'
  ),
  labelAgeYears: i18n._('Age (years)'),
  labelAgeMonths: i18n._('Age (months)'),
  labelSex: i18n._('Sex'),
  labelSexM: i18n._('Male'),
  labelSexF: i18n._('Female'),
  confirmPetRemoval(petName) {
    return i18n._(
      /* i18n: {0} will be either pet's name or 'this pet' */ t`Are you sure you want to remove ${petName ||
        'this pet'}?`
    );
  },
};

export const ConfirmedAvailabilityConstants = {
  headerTitle: i18n._('Your availability for the next 2 weeks'),
  editCalendar: i18n._('Edit my full calendar'),
  instructions: i18n._(
    'Want more requests that are right for you?<br/>Confirm your availability to highlight your profile in search results. Deselect any days you’re <span class="semibold-text">not</span> available.'
  ),
  confirmButtonText: i18n._('Confirm Availability'),
  popoverNew: i18n._('NEW'),
  popoverHeaderText: i18n._('Highlight your profile in search'),
  popoverParagrafText: i18n._(
    "Let potential clients know that you're available for new requests. Confirm your schedule over the next two weeks to highlight your profile in search."
  ),
  popoverLearnMoreLink: i18n._('Learn more'),
  popoverDismissLink: i18n._('Dismiss'),
};

export const ConfirmedAvailabilityCalendarButtonConstants = {
  popupText: i18n._('Confirm your availability to highlight your profile in the search results'),
  cancelButtonText: i18n._('Cancel'),
  modalTitle: i18n._('Is your calendar up-to-date for the next 2 weeks?'),
};

export const CheckboxCategoryConstants = {
  less: i18n._('Less'),
  more: i18n._('More'),
};
export const multiDatePickerConstants = {
  errorMessage: i18n._('Please select at least one date'),
};

export const petTypeButtonsConstants = {
  whatTypeOfPet: i18n._('What type of pet?'),
  cat: i18n._('Cat'),
  dog: i18n._('Dog'),
};

export const TimepickerConstants = {
  errorMessage: i18n._('Please select a time'),
  placeholder: i18n._('Select a time'),
  ariaLabel(label) {
    return i18n._(
      /* i18n: {label} is a service label e.g. "Visits", "Stay", "Walks" */ t`Time of ${label}`
    );
  },
};

export const TimepickerDayConstants = {
  addService(service) {
    return i18n._(
      /* i18n: {service} is a service label e.g. "Visit", "Walk" */ t`Add a ${service}`
    );
  },
};



// WEBPACK FOOTER //
// ./js/constants/translationConstants.js